<template>
    <!-- <div class="paddingContainer"> -->
        <div v-if="slide.type === 'emoji'" class="carouselSlide__line__block simple" :class="slide.specialClass">
            <div v-if="slide.specialClass !== undefined" class="carouselSlide__line__block__specialImg">
                <img src="/img/default/lobachevskyMobile.svg" alt="">
                <div class="carouselSlide__line__block__title">
                    {{ slide.title }}
                </div>
            </div>

            <div v-else class="carouselSlide__line__block__title">
                {{ slide.title }}
            </div>

            <div @click="$router.push(slide.link)" class="carouselSlide__line__block__link secondary-button">
                Подробнее
            </div>

            <div class="carouselSlide__line__block__emoji">
                {{ slide.src }}
            </div>
        </div>
    <!-- </div> -->

    <!-- <div class="paddingContainer"> -->
        <div v-else :style="{
            'background-image': 'url(' + require(`@/assets/img/mainPage/${slide.src}`) + ')',
            'background-color': '#12121299',
        }" class="carouselSlide__line__block imageBlock">
            <div class="carouselSlide__line__block__title">
                {{ slide.title }}
            </div>

            <div @click="$router.push(slide.link)" class="carouselSlide__line__block__link secondary-button">
                Подробнее
            </div>
        </div>
    <!-- </div> -->
</template>

<style scoped lang="scss" src="./style.scss"></style>

<style>
.carousel__slide.carousel__slide--visible.carousel__slide--active {}
</style>

<script src="./script.js"></script>